export enum OrderingBackendNameEnum {
  Name = 'Name',
  Created = 'DateCreated',
  Type = 'SurveyType',
  Status = 'TemplateStatus',
  Audience = 'SurveyAudience',
}
